/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Meta_DescriptionInputs */

const en_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Egly Method. Iowa PGA Teacher of the Year. Book a private golf lesson with Mark Egly, Golf Digest's #1 Iowa instructor for eight years.`)
};

const es_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El método Egly. Profesor del Año de la Iowa PGA. Reserva una lección privada con Mark Egly, el instructor #1 de Iowa según Golf Digest durante ocho años.`)
};

const de_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Egly-Methode. Lehrer des Jahres der Iowa PGA. Buchen Sie eine private Golfstunde bei Mark Egly, der laut Golf Digest acht Jahre lang der führende Golflehrer in Iowa war.`)
};

const zh_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method。Iowa PGA 年度最佳教师。与连续八年被 Golf Digest 评为爱荷华州排名第一的教练 Mark Egly 一起预订私人高尔夫课程。`)
};

const ar_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منهج Egly. معلم العام في Iowa PGA. احجز درس غولف خاصاً مع Mark Egly، المدرب رقم 1 في Iowa حسب Golf Digest لثماني سنوات.`)
};

const fr_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La méthode Egly. Enseignant de l’année de la Iowa PGA. Réservez une leçon de golf privée avec Mark Egly, instructeur n°1 de Golf Digest dans l'Iowa pendant huit ans.`)
};

const vi_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phương pháp Egly. Giáo viên của năm của Iowa PGA. Đặt buổi học golf riêng với Mark Egly, người từng là huấn luyện viên số 1 Iowa theo Golf Digest trong tám năm.`)
};

const sw_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mbinu ya Egly. Mwalimu Bora wa Mwaka wa Iowa PGA. Weka nafasi ya somo binafsi la gofu na Mark Egly, aliyekuwa mwalimu nambari 1 wa Iowa kwa mujibu wa Golf Digest kwa miaka minane.`)
};

const th_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method ครูแห่งปีของ Iowa PGA จองบทเรียนกอล์ฟแบบส่วนตัวกับ Mark Egly ผู้เคยเป็นผู้ฝึกสอนอันดับ 1 ของรัฐไอโอวาตาม Golf Digest เป็นเวลาแปดปี`)
};

const bs_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method. Učitelj godine Iowa PGA. Rezervišite privatnu lekciju golfa kod Marka Eglyja, koji je osam godina bio instruktor broj 1 u Iowi prema Golf Digestu.`)
};

const ja_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method。Iowa PGA 年間最優秀教師。8年連続 Golf Digest #1 アイオワインストラクター、Mark Eglyのプライベートゴルフレッソンを予約。`)
};

const ko_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly 메서드. Iowa PGA 올해의 교사. 8년간 Golf Digest #1 Iowa 강사였던 Mark Egly와 프라이빗 골프 레슨을 예약하세요.`)
};

const pt_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Egly Method. Professor do Ano da Iowa PGA. Agende uma aula particular de golfe com Mark Egly, o instrutor nº 1 de Iowa segundo a Golf Digest por oito anos.`)
};

const it_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’Egly Method. Insegnante dell’anno della Iowa PGA. Prenota una lezione di golf privata con Mark Egly, istruttore #1 dell’Iowa per Golf Digest per otto anni.`)
};

const sv_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method. Årets lärare i Iowa PGA. Boka en privat golflektion med Mark Egly, Golf Digests nr 1-instruktör i Iowa i åtta år.`)
};

const nl_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De Egly Method. Leraar van het Jaar van de Iowa PGA. Boek een privé-golfles bij Mark Egly, acht jaar lang de nummer 1 golfleraar van Iowa volgens Golf Digest.`)
};

const da_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method. Årets træner i Iowa PGA. Book en privat golftime hos Mark Egly, Golf Digests nr. 1-instruktør i Iowa i otte år.`)
};

const nb_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method. Årets lærer i Iowa PGA. Bestill en privat golftime hos Mark Egly, Golf Digests nr. 1-instruktør i Iowa i åtte år.`)
};

const fi_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method. Iowa PGA:n vuoden opettaja. Varaa yksityinen golftunti Mark Eglyltä, joka oli Golf Digestin Iowan ykkösvalmentaja kahdeksan vuoden ajan.`)
};

const pl_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method. Nauczyciel Roku Iowa PGA. Zarezerwuj prywatną lekcję golfa u Marka Egly’ego, który przez osiem lat był instruktorem nr 1 w Iowa według Golf Digest.`)
};

const ru_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метод Egly. Учитель года Iowa PGA. Запишитесь на частный урок гольфа к тренеру Mark Egly — инструктору №1 в Iowa по версии Golf Digest на протяжении восьми лет.`)
};

const tr_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method. Iowa PGA Yılın Öğretmeni. Golf Digest'e göre sekiz yıl boyunca Iowa'nın 1 numaralı eğitmeni olan Mark Egly ile özel golf dersi rezervasyonu yapın.`)
};

const hi_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method। Iowa PGA वर्ष के सर्वश्रेष्ठ शिक्षक। Mark Egly के साथ निजी गोल्फ पाठ बुक करें, जो आठ वर्षों तक Golf Digest के अनुसार Iowa के #1 प्रशिक्षक रहे।`)
};

const id_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method. Iowa PGA Teacher of the Year. Pesan les golf privat dengan Mark Egly, instruktur #1 Iowa versi Golf Digest selama delapan tahun.`)
};

const ms_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method. Iowa PGA Teacher of the Year. Tempah pelajaran golf persendirian bersama Mark Egly, jurulatih #1 Iowa versi Golf Digest selama lapan tahun.`)
};

const cs_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method. Učitel roku Iowa PGA. Rezervujte si soukromou lekci golfu s Markem Eglym, který byl osm let podle Golf Digest instruktorem č. 1 v Iowě.`)
};

const el_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η Μέθοδος Egly. Δάσκαλος της Χρονιάς της Iowa PGA. Κλείστε ιδιωτικό μάθημα γκολφ με τον Mark Egly, που για οκτώ χρόνια ήταν ο εκπαιδευτής #1 της Iowa κατά το Golf Digest.`)
};

const he_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Egly Method. מורה השנה של Iowa PGA. הזמינו שיעור גולף פרטי עם Mark Egly, המדריך מס' 1 באיווה לפי Golf Digest במשך שמונה שנים.`)
};

const af_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Egly-metode. Iowa PGA Onderwyser van die Jaar. Bespreek 'n privaat gholfles by Mark Egly, wat agt jaar lank Golf Digest se #1 Iowa-instrukteur was.`)
};

const hu_home_meta_description = /** @type {(inputs: Home_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az Egly Method. Az Iowa PGA év tanára. Foglalj privát golfórát Mark Eglyvel, aki nyolc éven át a Golf Digest szerint Iowa első számú oktatója volt.`)
};

/**
* | output |
* | --- |
* | "The Egly Method. Iowa PGA Teacher of the Year. Book a private golf lesson with Mark Egly, Golf Digest's #1 Iowa instructor for eight years." |
*
* @param {Home_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_meta_description = /** @type {((inputs?: Home_Meta_DescriptionInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Meta_DescriptionInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_meta_description(inputs)
	if (locale === "de") return de_home_meta_description(inputs)
	if (locale === "zh") return zh_home_meta_description(inputs)
	if (locale === "ar") return ar_home_meta_description(inputs)
	if (locale === "fr") return fr_home_meta_description(inputs)
	if (locale === "vi") return vi_home_meta_description(inputs)
	if (locale === "sw") return sw_home_meta_description(inputs)
	if (locale === "th") return th_home_meta_description(inputs)
	if (locale === "bs") return bs_home_meta_description(inputs)
	if (locale === "ja") return ja_home_meta_description(inputs)
	if (locale === "ko") return ko_home_meta_description(inputs)
	if (locale === "pt") return pt_home_meta_description(inputs)
	if (locale === "it") return it_home_meta_description(inputs)
	if (locale === "sv") return sv_home_meta_description(inputs)
	if (locale === "nl") return nl_home_meta_description(inputs)
	if (locale === "da") return da_home_meta_description(inputs)
	if (locale === "nb") return nb_home_meta_description(inputs)
	if (locale === "fi") return fi_home_meta_description(inputs)
	if (locale === "pl") return pl_home_meta_description(inputs)
	if (locale === "ru") return ru_home_meta_description(inputs)
	if (locale === "tr") return tr_home_meta_description(inputs)
	if (locale === "hi") return hi_home_meta_description(inputs)
	if (locale === "id") return id_home_meta_description(inputs)
	if (locale === "ms") return ms_home_meta_description(inputs)
	if (locale === "cs") return cs_home_meta_description(inputs)
	if (locale === "el") return el_home_meta_description(inputs)
	if (locale === "he") return he_home_meta_description(inputs)
	if (locale === "af") return af_home_meta_description(inputs)
	if (locale === "hu") return hu_home_meta_description(inputs)
	return en_home_meta_description(inputs)
});